var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.kommuner,"persistent-hint":"","item-text":_vm.getItemText,"item-value":"Nr","label":"Kommune","return-object":"","outlined":""},on:{"change":_vm.kommuneSelected},model:{value:(_vm.kommune),callback:function ($$v) {_vm.kommune=$$v},expression:"kommune"}})
}
var staticRenderFns = []

export { render, staticRenderFns }